import { render, staticRenderFns } from "./EntryDetailDrawer.vue?vue&type=template&id=80585858&scoped=true"
import script from "./EntryDetailDrawer.vue?vue&type=script&lang=js"
export * from "./EntryDetailDrawer.vue?vue&type=script&lang=js"
import style0 from "./EntryDetailDrawer.vue?vue&type=style&index=0&id=80585858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80585858",
  null
  
)

export default component.exports